import React from "react";
import BrainBankController from "./BrainBankController";

/**
 * Main BrainBank Management Component
 * This component serves as the entry point for all BrainBank management functionality
 */
const BrainBankManagement: React.FC = () => {
  return <BrainBankController />;
};

export default BrainBankManagement;